/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Search_Placeholder_ContactsInputs */



/**
* | output |
* | --- |
* | "Search by name, city, VEKN ID, email or Discord..." |
*
* @param {User_List_Search_Placeholder_ContactsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_search_placeholder_contacts = /** @type {((inputs?: User_List_Search_Placeholder_ContactsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Search_Placeholder_ContactsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom, ville, VEKN ID, e-mail ou Discord...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar por nombre, ciudad, ID VEKN, correo o Discord...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar por nome, cidade, VEKN ID, e-mail ou Discord...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca per nome, città, VEKN ID, email o Discord...")
	return /** @type {LocalizedString} */ ("Search by name, city, VEKN ID, email or Discord...")
});